import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFeatureFlags } from '../../../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../../../flags';
import { TermsContent } from './TermsContent';

interface ViewTermsDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ViewTermsDialog: FC<ViewTermsDialogProps> = ({
  open,
  onClose,
}) => {
  const { hasFeature } = useFeatureFlags();
  const showAICopy = hasFeature(FeatureFlags.NGW_AI_IMAGE_DESCRIPTIONS);

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="view-terms-dialog-title"
    >
      <DialogTitle
        id="view-terms-dialog-title"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 'h3.fontSize',
          fontWeight: 'h3.fontWeight',
        }}
      >
        Media Center Notice
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <TermsContent showAICopy={showAICopy} />
      </DialogContent>
    </Dialog>
  );
};
